import { Button, Flex, Space, Text } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { Checkmark } from '../../../../../../../../assets/images'

interface IntroScreenProps {
  onNext: () => void
  onBack: () => void
}

export const IntroScreen = ({ onNext, onBack }: IntroScreenProps) => {
  const { t } = useTranslation()
  return (
    <Flex alignContent="center" alignItems="center" flexDirection="column">
      <Checkmark />
      <Space size="s32" />
      <Text variant="h1">{t('vat_declarations.integration_form.intro.title')}</Text>
      <Space size="s8" />
      <Text alignment="center">{t('vat_declarations.integration_form.intro.body')}</Text>
      <Space size="s24" />
      <Button fullWidth onClick={onNext}>
        {t('vat_declarations.integration_form.intro.confirm')}
      </Button>
      <Space size="s16" />
      <Button fullWidth onClick={onBack} variant="text">
        {t('cancel')}
      </Button>
    </Flex>
  )
}
